import React from 'react';
import styled from 'styled-components';
import theme from '../../assets/styles/theme';
import Flex from './../Flex/Flex';
import Bullet from './../Bullet/Bullet';

const PillsInfo = () => {
  return (
    <>
      <Pill>
        <InfoBullet color={theme.oldColors.teal[100]} />
        <PillText color={theme.oldColors.grey[600]}>Acreditados</PillText>
      </Pill>
      <Pill>
        <InfoBullet color={theme.oldColors.blue[100]} />
        <PillText color={theme.oldColors.grey[600]}>Por Acreditar</PillText>
      </Pill>
      <Pill>
        <InfoBullet color={theme.oldColors.orange[100]} />
        <PillText color={theme.oldColors.grey[600]}>Estimados</PillText>
      </Pill>
      <Pill>
        <InfoBullet color={theme.oldColors.red[100]} />
        <PillText color={theme.oldColors.grey[600]}>Feriado</PillText>
      </Pill>
    </>
  );
};

const Pill = styled(Flex)`
  border-radius: 20px;
  border: solid 1px #e8e8e8;
  align-items: center;
  padding: 5px 20px 5px 1px;
  margin-left: 20px;
`;

const PillText = styled.span`
  font-size: 14px;
  color: ${theme.oldColors.grey[600]};
`;

const InfoBullet = styled(Bullet)`
  margin: 10px;
`;

export default PillsInfo;
